import { defineComponent as B, computed as r, useCssVars as h, ref as d, onMounted as A, onBeforeUnmount as I, watch as j, nextTick as O, reactive as m } from "vue";
function i(n, e, t, s, a, l, o, u) {
  var c = typeof n == "function" ? n.options : n;
  e && (c.render = e, c.staticRenderFns = t, c._compiled = !0), s && (c.functional = !0), l && (c._scopeId = "data-v-" + l);
  var _;
  if (o ? (_ = function(v) {
    v = v || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !v && typeof __VUE_SSR_CONTEXT__ < "u" && (v = __VUE_SSR_CONTEXT__), a && a.call(this, v), v && v._registeredComponents && v._registeredComponents.add(o);
  }, c._ssrRegister = _) : a && (_ = u ? function() {
    a.call(
      this,
      (c.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), _)
    if (c.functional) {
      c._injectStyles = _;
      var p = c.render;
      c.render = function(g, w) {
        return _.call(w), p(g, w);
      };
    } else {
      var f = c.beforeCreate;
      c.beforeCreate = f ? [].concat(f, _) : [_];
    }
  return {
    exports: n,
    options: c
  };
}
const Z = {
  name: "c-spinner",
  props: {
    loading: {
      type: Boolean,
      default: !0
    },
    color: {
      type: String,
      default: "#888888"
    },
    size: {
      type: String,
      default: "24px"
    }
  },
  computed: {
    spinnerStyle() {
      return {
        height: this.size,
        width: this.size
      };
    },
    spinnerClipStyle() {
      return {
        height: this.size,
        width: this.size,
        borderColor: `${this.color} ${this.color} transparent`
      };
    }
  }
};
var L = function() {
  var e = this, t = e._self._c;
  return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.loading, expression: "loading" }], staticClass: "c-spinner", style: e.spinnerStyle }, [t("span", { staticClass: "c-spinner_clip", style: e.spinnerClipStyle })]);
}, N = [], H = /* @__PURE__ */ i(
  Z,
  L,
  N,
  !1,
  null,
  "a4ed6aa3",
  null,
  null
);
const b = H.exports, q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b
}, Symbol.toStringTag, { value: "Module" })), E = ["primary", "outlined", "text"], D = ["large", "medium"];
const U = B({
  name: "c-button",
  components: { CSpinner: b },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      validator(n) {
        return E.includes(n);
      },
      default: "primary"
    },
    size: {
      type: String,
      validator(n) {
        return D.includes(n);
      },
      default: "large"
    },
    type: {
      type: String,
      default: "button"
    }
  },
  setup(n, e) {
    const t = r(() => ({
      [`c-button--${n.variant}`]: !0,
      [`c-button--${n.size}`]: !0,
      "c-button--no-text": !e.slots.default,
      "c-button--disabled": n.disabled,
      "c-button--loading": n.disabled
    })), s = r(() => {
      switch (n.variant) {
        case "primary":
          return "#FFFFFF";
        case "outlined":
        case "text":
          return "#000000";
        default:
          return "#555555";
      }
    });
    return {
      classes: t,
      spinnerColor: s
    };
  }
});
var X = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("button", e._g(e._b({ staticClass: "c-button snz-txt-btn", class: e.classes, attrs: { disabled: e.disabled || e.loading } }, "button", e.$attrs, !1), e.$listeners), [e.loading ? t("c-spinner", { attrs: { loading: "", color: e.spinnerColor } }) : [e.$slots.prepend ? t("span", { staticClass: "c-button_prepend" }, [e._t("prepend")], 2) : e._e(), e._t("default"), e.$slots.append ? t("span", { staticClass: "c-button_append" }, [e._t("append")], 2) : e._e()]], 2);
}, W = [], G = /* @__PURE__ */ i(
  U,
  X,
  W,
  !1,
  null,
  "ff3e7155",
  null,
  null
);
const J = G.exports, K = ["c-avatar", () => Promise.resolve().then(() => Pe)], Q = ["c-button", J], Y = ["c-spinner", () => Promise.resolve().then(() => q)], ee = ["c-tag", () => Promise.resolve().then(() => Re)], te = ["c-bubble", () => Promise.resolve().then(() => Ne)], ne = ["c-thumb", () => Promise.resolve().then(() => Xe)], se = ["c-image", () => Promise.resolve().then(() => Ye)], ae = ["c-checkbox", () => Promise.resolve().then(() => ct)], le = ["c-input", () => Promise.resolve().then(() => mt)], ce = ["c-fileinput", () => Promise.resolve().then(() => St)], re = ["c-radio", () => Promise.resolve().then(() => Vt)], oe = ["c-textarea", () => Promise.resolve().then(() => Bt)], ie = ["c-toggle", () => Promise.resolve().then(() => Ht)], _e = ["c-filter", () => Promise.resolve().then(() => Gt)], ue = ["c-select", () => Promise.resolve().then(() => tn)], de = ["c-select-multi", () => Promise.resolve().then(() => rn)], pe = ["c-divider", () => Promise.resolve().then(() => vn)], ve = ["c-card", () => Promise.resolve().then(() => yn)], fe = ["c-modal", () => Promise.resolve().then(() => Tn)], me = ["c-tabs", () => Promise.resolve().then(() => jn)], ge = ["c-timeline", () => Promise.resolve().then(() => Ln)], he = ["c-timeline-item", () => Promise.resolve().then(() => Wn)], be = ["c-dotmenu", () => Promise.resolve().then(() => ns)], ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  avatar: K,
  button: Q,
  spinner: Y,
  tag: ee,
  bubble: te,
  thumb: ne,
  image: se,
  checkbox: ae,
  input: le,
  fileinput: ce,
  radio: re,
  textarea: oe,
  toggle: ie,
  filter: _e,
  select: ue,
  selectMulti: de,
  divider: pe,
  card: ve,
  modal: fe,
  tabs: me,
  timeline: ge,
  timelineItem: he,
  dotmenu: be
}, Symbol.toStringTag, { value: "Module" }));
const F = {}, $e = (n) => {
  Object.assign(F, n);
}, as = {
  test: {},
  install(n, e = {}) {
    n.prototype.$crayon || ($e(e), Object.values(ye).forEach(([t, s]) => n.component(t, s)), n.prototype.$crayon = {
      config: F
    });
  }
}, xe = ["medium", "small"];
const Ce = {
  name: "c-avatar",
  components: {},
  props: {
    src: { type: String },
    label: { type: String },
    rounded: { type: Boolean, default: !1 },
    light: { type: Boolean, default: !1 },
    size: {
      type: String,
      default: "medium",
      validator(n) {
        return xe.includes(n);
      }
    }
  },
  setup(n) {
    return { classes: r(() => ({
      "c-avatar--rounded": n.rounded,
      [`c-avatar--${n.size}`]: !0,
      "c-avatar--image": n.src,
      "c-avatar--light": n.light
    })) };
  },
  methods: {}
};
var Se = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-avatar", class: e.classes }, [e.src ? t("img", { staticClass: "c-avatar_img", attrs: { src: e.src } }) : e.label ? t("span", { staticClass: "c-avatar_label" }, [e._v(e._s(e.label))]) : e._e()]);
}, we = [], Te = /* @__PURE__ */ i(
  Ce,
  Se,
  we,
  !1,
  null,
  "c3414467",
  null,
  null
);
const ke = Te.exports, Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ke
}, Symbol.toStringTag, { value: "Module" })), ze = ["primary", "outlined"];
const Ve = {
  name: "c-tag",
  components: {},
  props: {
    variant: {
      type: String,
      validator(n) {
        return ze.includes(n);
      },
      default: "primary"
    },
    rounded: { type: Boolean, default: !0 }
  },
  setup(n) {
    return { classes: r(() => ({
      [`c-tag--${n.variant}`]: !0,
      "c-tag--rounded": n.rounded
    })) };
  }
};
var Me = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-tag", class: e.classes }, [e.$slots.prepend ? t("span", { staticClass: "c-tag_prepend" }, [e._t("prepend")], 2) : e._e(), e._t("default"), e.$slots.append ? t("span", { staticClass: "c-tag_append" }, [e._t("append")], 2) : e._e()], 2);
}, je = [], Oe = /* @__PURE__ */ i(
  Ve,
  Me,
  je,
  !1,
  null,
  "c31f0159",
  null,
  null
);
const Fe = Oe.exports, Re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fe
}, Symbol.toStringTag, { value: "Module" }));
const y = {
  name: "c-bubble",
  components: {},
  props: {
    size: {
      type: String,
      default: "20px"
    },
    color: {
      type: String,
      default: "#FFF"
    },
    border: {
      type: String,
      default: "transparent"
    }
  }
}, T = () => {
  h((n, e) => ({
    "055e7493": n.size,
    b4dda5de: n.color,
    "0ae22c3e": n.border
  }));
}, k = y.setup;
y.setup = k ? (n, e) => (T(), k(n, e)) : T;
const Be = y;
var Ae = function() {
  var e = this, t = e._self._c;
  return t("span", e._g({ staticClass: "c-bubble snz-elevation-1" }, e.$listeners));
}, Ie = [], Ze = /* @__PURE__ */ i(
  Be,
  Ae,
  Ie,
  !1,
  null,
  "e0636082",
  null,
  null
);
const Le = Ze.exports, Ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Le
}, Symbol.toStringTag, { value: "Module" }));
const $ = {
  name: "c-thumb",
  components: {},
  props: {
    width: {
      type: String,
      default: "auto"
    },
    height: {
      type: String,
      default: "auto"
    }
  }
}, P = () => {
  h((n, e) => ({
    "2905e448": n.height
  }));
}, z = $.setup;
$.setup = z ? (n, e) => (P(), z(n, e)) : P;
const He = $;
var qe = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-thumb" }, [t("div", { staticClass: "c-thumb_media" }, [e._t("default")], 2), e.$slots.label ? t("div", { staticClass: "c-thumb_label snz-txt-pre" }, [e._t("label")], 2) : e._e()]);
}, Ee = [], De = /* @__PURE__ */ i(
  He,
  qe,
  Ee,
  !1,
  null,
  "0690e5ca",
  null,
  null
);
const Ue = De.exports, Xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ue
}, Symbol.toStringTag, { value: "Module" }));
const We = {
  name: "c-image",
  components: {},
  props: {
    src: {
      type: String,
      required: !0
    },
    width: {
      type: String,
      default: "auto"
    },
    height: {
      type: String,
      default: "auto"
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    objectFit: {
      type: String,
      default: "contain"
    }
  },
  setup(n) {
    const e = d(!1), t = d(null), s = d(!1), a = (l) => {
      if (!e.value)
        return;
      l.style.cssText = `
        display: block;
        width: ${n.width};
        height: ${n.height};
        object-fit: ${n.objectFit};
        border-radius: ${n.rounded ? 9999 : 0}px;
      `;
      const o = t.value;
      O(() => {
        o.replaceChild(l, o.lastChild), s.value = !1;
      });
    };
    return A(() => {
      e.value = !0;
    }), I(() => {
      e.value = !1, s.value = !1;
    }), j(() => n.src, async () => {
      if (!n.src)
        return;
      s.value = !0;
      const l = new Image();
      if (l.decode)
        try {
          l.src = n.src, await l.decode(), a(l);
          return;
        } catch {
          console.log("Img async decoding error, fallback to normal behavior");
        }
      if (l.loading = "eager", l.decoding = "sync", l.complete && l.currentSrc === n.src) {
        a(l);
        return;
      }
      l.onload = () => a(l), l.src = n.src;
    }, { immediate: !0 }), {
      component: t,
      loading: s,
      classes: r(() => ({
        "c-image--visible": e.value,
        "c-image--loading": s.value,
        "c-image--rounded": n.rounded
      })),
      style: r(() => ({
        width: n.width,
        height: n.height
      }))
    };
  }
};
var Ge = function() {
  var e = this, t = e._self._c;
  return t("div", e._g({ ref: "component", staticClass: "c-image", class: e.classes, style: e.style }, e.$listeners), [t("div", { staticClass: "c-image_loader" })]);
}, Je = [], Ke = /* @__PURE__ */ i(
  We,
  Ge,
  Je,
  !1,
  null,
  null,
  null,
  null
);
const Qe = Ke.exports, Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qe
}, Symbol.toStringTag, { value: "Module" })), x = () => Math.random().toString(36).substring(2, 9);
var et = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M18.05 8.051 9.101 17 5 12.899l1.051-1.052 3.05 3.043L16.998 7l1.052 1.051Z", fill: "currentColor" } })]);
};
const tt = {
  render: et
};
const nt = {
  name: "c-checkbox",
  components: { CheckIcon: tt },
  model: {
    prop: "selection",
    event: "selectionChange"
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: x
    },
    selection: {
      type: [Array, Boolean],
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  setup(n, { emit: e }) {
    const t = d(null), s = d(!Array.isArray(n.selection)), a = r(() => s.value ? !!n.selection : n.selection.includes(n.value));
    return {
      inputValue: r({
        get: () => a.value,
        set: (o) => {
          s.value ? e("selectionChange", o) : a.value ? e("selectionChange", n.selection.filter((u) => u !== n.value)) : e("selectionChange", [...n.selection, n.value]);
        }
      }),
      input: t,
      isBooleanModel: s,
      isChecked: a,
      classes: r(() => ({
        "c-checkbox--checked": a.value,
        "c-checkbox--disabled": n.disabled
      }))
    };
  }
};
var st = function() {
  var e = this, t = e._self._c;
  return t("span", { staticClass: "c-checkbox", class: e.classes, on: { click: function(s) {
    return s.stopPropagation(), e.input.click();
  } } }, [t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], ref: "input", attrs: { type: "checkbox", id: e.id, disabled: e.disabled }, domProps: { value: e.value, checked: Array.isArray(e.inputValue) ? e._i(e.inputValue, e.value) > -1 : e.inputValue }, on: { change: function(s) {
    var a = e.inputValue, l = s.target, o = !!l.checked;
    if (Array.isArray(a)) {
      var u = e.value, c = e._i(a, u);
      l.checked ? c < 0 && (e.inputValue = a.concat([u])) : c > -1 && (e.inputValue = a.slice(0, c).concat(a.slice(c + 1)));
    } else
      e.inputValue = o;
  } } }, "input", e.$attrs, !1), e.$listeners)), e.isChecked ? t("check-icon", { staticClass: "c-checkbox_check" }) : e._e(), t("label", { staticClass: "snz-txt-body-2", attrs: { for: e.id } }, [e._t("default")], 2)], 1);
}, at = [], lt = /* @__PURE__ */ i(
  nt,
  st,
  at,
  !1,
  null,
  "90a7102d",
  null,
  null
);
const R = lt.exports, ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R
}, Symbol.toStringTag, { value: "Module" }));
var rt = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0-4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5ZM3.18 12a9.821 9.821 0 0 0 17.64 0 9.821 9.821 0 0 0-17.64 0Z", fill: "currentColor" } })]);
};
const ot = {
  render: rt
};
var it = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M2 5.27 3.28 4 20 20.72 18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58-5 0-9.27-3.11-11-7.5.69-1.76 1.79-3.31 3.19-4.54L2 5.27ZM12 9a3 3 0 0 1 2.83 4L11 9.17A3 3 0 0 1 12 9Zm0-4.5c5 0 9.27 3.11 11 7.5a11.79 11.79 0 0 1-4 5.19l-1.42-1.43A9.862 9.862 0 0 0 20.82 12 9.821 9.821 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97ZM3.18 12A9.821 9.821 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13Z", fill: "currentColor" } })]);
};
const _t = {
  render: it
};
const ut = {
  name: "c-input",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "text"
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(n, { emit: e, listeners: t }) {
    const s = d(!1), { change: a, ...l } = t, o = r({
      get: () => n.value,
      set: (u) => e("change", u)
    });
    return {
      nativeListeners: l,
      showText: s,
      inputValue: o,
      classes: r(() => ({
        [`c-input--${n.variant}`]: !0
      }))
    };
  }
};
var dt = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-input", class: e.classes }, [e.$slots.prepend ? t("div", { staticStyle: { "padding-right": "4px" } }, [e._t("prepend")], 2) : e._e(), (e.showText ? "text" : e.type) === "checkbox" ? t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], staticClass: "snz-txt-body-2", attrs: { type: "checkbox" }, domProps: { checked: Array.isArray(e.inputValue) ? e._i(e.inputValue, null) > -1 : e.inputValue }, on: { change: function(s) {
    var a = e.inputValue, l = s.target, o = !!l.checked;
    if (Array.isArray(a)) {
      var u = null, c = e._i(a, u);
      l.checked ? c < 0 && (e.inputValue = a.concat([u])) : c > -1 && (e.inputValue = a.slice(0, c).concat(a.slice(c + 1)));
    } else
      e.inputValue = o;
  } } }, "input", e.$attrs, !1), e.nativeListeners)) : (e.showText ? "text" : e.type) === "radio" ? t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], staticClass: "snz-txt-body-2", attrs: { type: "radio" }, domProps: { checked: e._q(e.inputValue, null) }, on: { change: function(s) {
    e.inputValue = null;
  } } }, "input", e.$attrs, !1), e.nativeListeners)) : t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], staticClass: "snz-txt-body-2", attrs: { type: e.showText ? "text" : e.type }, domProps: { value: e.inputValue }, on: { input: function(s) {
    s.target.composing || (e.inputValue = s.target.value);
  } } }, "input", e.$attrs, !1), e.nativeListeners)), e.type === "password" ? t("div", { staticClass: "c-input_append", on: { click: function(s) {
    e.showText = !e.showText;
  } } }, [e.showText ? t("img", { attrs: { src: ot } }) : t("img", { attrs: { src: _t } })]) : e.$slots.append ? t("div", { staticStyle: { "padding-left": "4px" } }, [e._t("append")], 2) : e._e()]);
}, pt = [], vt = /* @__PURE__ */ i(
  ut,
  dt,
  pt,
  !1,
  null,
  "a8b16e56",
  null,
  null
);
const ft = vt.exports, mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ft
}, Symbol.toStringTag, { value: "Module" }));
var gt = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M9 16v-6H5l7-7 7 7h-4v6H9Zm-4 4v-2h14v2H5Z", fill: "#000" } })]);
};
const ht = {
  render: gt
};
const bt = {
  name: "c-fileinput",
  components: {
    UploadIcon: ht,
    CSpinner: b
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const n = d(null);
    return {
      fileinput: n,
      focus: () => {
        n.value.click();
      }
    };
  }
};
var yt = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-fileinput", on: { click: e.focus } }, [t("input", e._g(e._b({ ref: "fileinput", attrs: { type: "file" } }, "input", e.$attrs, !1), e.$listeners)), t("div", { staticClass: "c-fileinput_prepend", staticStyle: { "padding-right": "4px" } }, [e.$slots.prepend ? [e._t("prepend")] : t("upload-icon")], 2), t("span", { staticClass: "c-fileinput_label snz-txt-body-2" }, [e._t("default")], 2), t("div", { staticClass: "c-fileinput_append" }, [e.$slots.append ? [e._t("append")] : t("c-spinner", { attrs: { loading: e.loading } })], 2)]);
}, $t = [], xt = /* @__PURE__ */ i(
  bt,
  yt,
  $t,
  !1,
  null,
  "fe16a1e6",
  null,
  null
);
const Ct = xt.exports, St = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ct
}, Symbol.toStringTag, { value: "Module" }));
const wt = {
  name: "c-radio",
  model: {
    prop: "selected",
    event: "selectedChange"
  },
  props: {
    selected: {
      type: String,
      default: null
    },
    value: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: x
    }
  },
  setup(n, { emit: e }) {
    const t = r({
      get: () => n.selected,
      set: (l) => e("selectedChange", l)
    }), s = d(null), a = r(() => n.selected === n.value);
    return {
      input: s,
      inputValue: t,
      isSelected: a,
      classes: r(() => ({
        "c-radio--checked": a.value,
        "c-radio--disabled": n.disabled
      }))
    };
  }
};
var Tt = function() {
  var e = this, t = e._self._c;
  return t("span", { staticClass: "c-radio", class: e.classes, on: { click: function(s) {
    return e.input.click();
  } } }, [t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], ref: "input", attrs: { type: "radio", id: e.id, disabled: e.disabled }, domProps: { value: e.value, checked: e._q(e.inputValue, e.value) }, on: { change: function(s) {
    e.inputValue = e.value;
  } } }, "input", e.$attrs, !1), e.$listeners)), t("label", { staticClass: "snz-txt-body-2", attrs: { for: e.id } }, [e._t("default")], 2)]);
}, kt = [], Pt = /* @__PURE__ */ i(
  wt,
  Tt,
  kt,
  !1,
  null,
  "7dff6da9",
  null,
  null
);
const zt = Pt.exports, Vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zt
}, Symbol.toStringTag, { value: "Module" }));
const Mt = {
  name: "c-textarea",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {},
    placeholder: { type: String },
    disabled: { type: Boolean }
  },
  setup(n, { emit: e, listeners: t }) {
    const s = r(() => ({
      "snz-textarea--disabled": n.disabled
    })), a = r({
      get: () => n.value,
      set: (u) => e("change", u)
    }), { change: l, ...o } = t;
    return { nativeListeners: o, inputValue: a, classes: s };
  }
};
var jt = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-textarea" }, [t("textarea", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], class: e.classes, attrs: { disabled: e.disabled, placeholder: e.placeholder }, domProps: { value: e.inputValue }, on: { input: function(s) {
    s.target.composing || (e.inputValue = s.target.value);
  } } }, "textarea", e.$attrs, !1), e.nativeListeners))]);
}, Ot = [], Ft = /* @__PURE__ */ i(
  Mt,
  jt,
  Ot,
  !1,
  null,
  "7bf1de64",
  null,
  null
);
const Rt = Ft.exports, Bt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rt
}, Symbol.toStringTag, { value: "Module" }));
const At = {
  name: "c-toggle",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: x
    }
  },
  setup(n, { emit: e, listeners: t }) {
    const { change: s, ...a } = t;
    return {
      inputValue: r({
        get: () => n.checked,
        set: (o) => e("change", o)
      }),
      nativeListeners: a,
      classes: r(() => ({
        "c-toggle--checked": n.checked,
        "c-toggle--disabled": n.disabled
      }))
    };
  }
};
var It = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-toggle", class: e.classes }, [t("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: e.inputValue, expression: "inputValue" }], attrs: { id: e.id, type: "checkbox", disabled: e.disabled }, domProps: { checked: Array.isArray(e.inputValue) ? e._i(e.inputValue, null) > -1 : e.inputValue }, on: { change: function(s) {
    var a = e.inputValue, l = s.target, o = !!l.checked;
    if (Array.isArray(a)) {
      var u = null, c = e._i(a, u);
      l.checked ? c < 0 && (e.inputValue = a.concat([u])) : c > -1 && (e.inputValue = a.slice(0, c).concat(a.slice(c + 1)));
    } else
      e.inputValue = o;
  } } }, "input", e.$attrs, !1), e.nativeListeners)), t("div", { staticClass: "slider round" }), t("label", { staticClass: "snz-txt-body-2", attrs: { for: e.id } }, [e._t("default")], 2)]);
}, Zt = [], Lt = /* @__PURE__ */ i(
  At,
  It,
  Zt,
  !1,
  null,
  "c2b07985",
  null,
  null
);
const Nt = Lt.exports, Ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nt
}, Symbol.toStringTag, { value: "Module" }));
var qt = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "m7 9 5 5 5-5H7Z", fill: "#000", "fill-opacity": ".6" } })]);
};
const C = {
  render: qt
};
const Et = {
  name: "c-filter",
  components: { MenuDownIcon: C },
  setup() {
    const n = d(null), e = d(!1), t = m({
      top: "0px",
      left: "0px"
    });
    return {
      component: n,
      open: () => {
        const a = n.value.getBoundingClientRect();
        t.top = `${a.bottom}px`, t.left = `${a.left}px`, e.value = !0;
      },
      opened: e,
      selectorPosition: t,
      classes: r(() => ({
        "c-filter--opened": e.value
      }))
    };
  }
};
var Dt = function() {
  var e = this, t = e._self._c;
  return t("span", { ref: "component", staticClass: "c-filter", class: e.classes, on: { click: e.open } }, [e.opened ? t("div", { staticClass: "c-filter_overlay", on: { click: function(s) {
    s.stopPropagation(), e.opened = !1;
  } } }) : e._e(), e.$slots.prepend ? t("div", { staticClass: "flex", staticStyle: { "padding-right": "4px" } }, [e._t("prepend")], 2) : e._e(), t("span", { staticClass: "snz-txt-body-2 mx1" }, [e._t("default")], 2), t("menu-down-icon", { staticClass: "c-filter_chevron" }), t("Transition", { attrs: { appear: "" } }, [e.opened ? t("div", { staticClass: "c-filter_selector", style: e.selectorPosition }, [e._t("selector", null, { close: () => e.opened = !1 })], 2) : e._e()])], 1);
}, Ut = [], Xt = /* @__PURE__ */ i(
  Et,
  Dt,
  Ut,
  !1,
  null,
  "a5170d5c",
  null,
  null
);
const Wt = Xt.exports, Gt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wt
}, Symbol.toStringTag, { value: "Module" }));
const Jt = {
  name: "c-select",
  components: { MenuDownIcon: C },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: null,
    items: {
      type: Array,
      required: !0
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(n, { emit: e, slots: t }) {
    const s = d(null), a = d(!1), l = m({
      top: "0px",
      left: "0px",
      maxHeight: "1000px"
    }), o = () => {
      const _ = s.value.getBoundingClientRect();
      l.top = `${_.bottom}px`, l.left = `${_.left}px`, l.width = `${_.width}px`, l.maxHeight = `${window.innerHeight - 8 - _.bottom}px`, a.value = !0;
    }, u = (_) => {
      e("change", _[n.itemValue] || _), a.value = !1;
    }, c = r(() => Array.isArray(n.items) && n.value ? n.items.find((_) => n.value === (_[n.itemValue] || _)) : null);
    return {
      component: s,
      open: o,
      opened: a,
      select: u,
      slots: t,
      selected: c,
      selectorPosition: l,
      classes: r(() => ({
        "c-select--opened": a.value,
        [`c-select--${n.variant}`]: !0
      }))
    };
  }
};
var Kt = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "component", staticClass: "c-select", class: e.classes, on: { click: e.open } }, [e.opened ? t("div", { staticClass: "c-select_overlay", on: { click: function(s) {
    s.stopPropagation(), e.opened = !1;
  } } }) : e._e(), e.$slots.prepend ? t("div", { staticClass: "flex", staticStyle: { "padding-right": "4px" } }, [e._t("prepend")], 2) : e._e(), t("span", { staticClass: "c-select_content snz-txt-body-2" }, [e.selected ? e.slots.selected ? [e._t("selected", null, { item: e.selected })] : [e._v(" " + e._s(e.selected[e.itemText] || e.selected) + " ")] : [e._v(" " + e._s(e.placeholder) + " ")]], 2), t("menu-down-icon", { staticClass: "c-select_chevron" }), t("Transition", { attrs: { appear: "" } }, [e.opened && e.items ? t("div", { staticClass: "c-select_selector snz-scrollable", style: e.selectorPosition }, e._l(e.items, function(s, a) {
    return t("div", { key: a, on: { click: function(l) {
      return l.stopPropagation(), e.select(s);
    } } }, [t("div", { staticClass: "snz-menu-entry snz-txt-menu p1" }, [e.slots.option ? [e._t("option", null, { item: s })] : [e._v(e._s(s[e.itemText] || s))]], 2)]);
  }), 0) : e._e()])], 1);
}, Qt = [], Yt = /* @__PURE__ */ i(
  Jt,
  Kt,
  Qt,
  !1,
  null,
  "23001d8b",
  null,
  null
);
const en = Yt.exports, tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: en
}, Symbol.toStringTag, { value: "Module" }));
const nn = {
  name: "c-select-multi",
  components: { CCheckbox: R, MenuDownIcon: C },
  model: {
    prop: "values",
    event: "change"
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      required: !0
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(n, { emit: e, slots: t }) {
    const s = d(null), a = d(!1), l = m({
      top: "0px",
      left: "0px",
      maxHeight: "1000px"
    }), o = () => {
      const p = s.value.getBoundingClientRect();
      l.top = `${p.bottom}px`, l.left = `${p.left}px`, l.width = `${p.width}px`, l.maxHeight = `${window.innerHeight - 8 - p.bottom}px`, a.value = !0;
    }, u = (p) => {
      const f = p[n.itemValue] || p;
      n.values.indexOf(f) >= 0 ? e("change", n.values.filter((g) => g !== f)) : e("change", [...n.values, f]);
    }, c = r(() => Array.isArray(n.items) && n.values ? n.items.filter((p) => n.values.includes(p[n.itemValue] || p)) : []), _ = r({
      get: () => n.values,
      set: (p) => {
        e("change", p);
      }
    });
    return {
      component: s,
      open: o,
      opened: a,
      select: u,
      slots: t,
      selection: c,
      valuesModel: _,
      selectorPosition: l,
      classes: r(() => ({
        "c-select--opened": a.value,
        [`c-select--${n.variant}`]: !0
      }))
    };
  }
};
var sn = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "component", staticClass: "c-select", class: e.classes, on: { click: e.open } }, [e.opened ? t("div", { staticClass: "c-select_overlay", on: { click: function(s) {
    s.stopPropagation(), e.opened = !1;
  } } }) : e._e(), e.$slots.prepend ? t("div", { staticClass: "flex", staticStyle: { "padding-right": "4px" } }, [e._t("prepend")], 2) : e._e(), t("span", { staticClass: "c-select_content snz-txt-body-2" }, [e.selection.length ? e.slots.selected ? [e._t("selected", null, { items: e.selection })] : [e._v(" " + e._s(e.selection[0][e.itemText] || e.selection[0]) + e._s(e.selection.length > 1 ? ` + ${e.selection.length - 1}` : "") + " ")] : [e._v(" " + e._s(e.placeholder) + " ")]], 2), t("menu-down-icon", { staticClass: "c-select_chevron" }), t("Transition", { attrs: { appear: "" } }, [e.opened && e.items ? t("div", { staticClass: "c-select_selector snz-scrollable", style: e.selectorPosition }, e._l(e.items, function(s, a) {
    return t("div", { key: a, on: { click: function(l) {
      return l.stopPropagation(), e.select(s);
    } } }, [t("div", { staticClass: "snz-menu-entry p1" }, [e.slots.option ? [e._t("option", null, { item: s })] : t("c-checkbox", { attrs: { value: s[e.itemText] || s }, model: { value: e.valuesModel, callback: function(l) {
      e.valuesModel = l;
    }, expression: "valuesModel" } }, [e._v(e._s(s[e.itemText] || s))])], 2)]);
  }), 0) : e._e()])], 1);
}, an = [], ln = /* @__PURE__ */ i(
  nn,
  sn,
  an,
  !1,
  null,
  "b0f0e8e6",
  null,
  null
);
const cn = ln.exports, rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cn
}, Symbol.toStringTag, { value: "Module" }));
const on = {
  name: "c-divider",
  props: {
    label: { type: String, default: "" }
  }
};
var _n = function() {
  var e = this, t = e._self._c;
  return e.label ? t("div", { staticClass: "c-divider" }, [t("span", { staticClass: "line" }), t("span", { staticClass: "snz-txt-h6" }, [e._v(" " + e._s(e.label) + " ")]), t("span", { staticClass: "line" })]) : t("div", { staticClass: "c-divider-line" });
}, un = [], dn = /* @__PURE__ */ i(
  on,
  _n,
  un,
  !1,
  null,
  "094517ab",
  null,
  null
);
const pn = dn.exports, vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pn
}, Symbol.toStringTag, { value: "Module" }));
const S = {
  name: "c-card",
  props: {
    width: { type: String, default: "auto" },
    elevation: { type: Number, default: 2 }
  },
  setup(n) {
    return { classes: r(() => ({
      [`c-card--elevation-${n.elevation}`]: !0
    })) };
  }
}, V = () => {
  h((n, e) => ({
    "01ffeedb": n.width
  }));
}, M = S.setup;
S.setup = M ? (n, e) => (V(), M(n, e)) : V;
const fn = S;
var mn = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-card", class: e.classes }, [e.$slots.header ? [t("div", { staticClass: "c-card_header" }, [e._t("header")], 2)] : e._e(), t("div", { staticClass: "c-card_content snz-scrollable" }, [e._t("default")], 2), e.$slots.footer ? [t("div", { staticClass: "c-card_footer" }, [e._t("footer")], 2)] : e._e()], 2);
}, gn = [], hn = /* @__PURE__ */ i(
  fn,
  mn,
  gn,
  !1,
  null,
  "d7cc1fd1",
  null,
  null
);
const bn = hn.exports, yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bn
}, Symbol.toStringTag, { value: "Module" }));
const $n = {
  name: "c-modal",
  props: {
    show: {
      type: Boolean,
      default: !1
    }
  },
  model: {
    prop: "show",
    event: "setShown"
  },
  setup(n) {
    const e = d(!1);
    return j(() => n.show, (t) => {
      setTimeout(() => {
        e.value = t;
      }, t ? 0 : 600);
    }), {
      visible: e
    };
  }
};
var xn = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-modal", style: `visibility: ${e.visible ? "visible" : "hidden"}` }, [t("Transition", { attrs: { appear: "" } }, [e.show ? t("div", { staticClass: "c-modal_overlay", on: { click: function(s) {
    return e.$emit("setShown", !1);
  } } }) : e._e()]), t("Transition", { attrs: { appear: "" } }, [e.show ? t("div", { staticClass: "c-modal_content" }, [e._t("default")], 2) : e._e()])], 1);
}, Cn = [], Sn = /* @__PURE__ */ i(
  $n,
  xn,
  Cn,
  !1,
  null,
  "0b6b00a2",
  null,
  null
);
const wn = Sn.exports, Tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wn
}, Symbol.toStringTag, { value: "Module" }));
const kn = {
  name: "c-tabs",
  props: {
    selected: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      required: !0
    }
  },
  model: {
    prop: "selected",
    event: "change"
  },
  setup(n, { emit: e }) {
    return { updateTab: (s) => {
      O(() => {
        e("change", s);
      });
    } };
  }
};
var Pn = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "c-tabs px2" }, [e.$slots.label ? [t("span", { staticClass: "c-tabs_label snz-txt-menu" }, [e._t("label")], 2)] : e._e(), e._l(e.tabs, function(s, a) {
    return t("span", { key: a, staticClass: "c-tabs_tab snz-txt-menu relative", on: { click: function(l) {
      return e.updateTab(a);
    } } }, [e._v(" " + e._s(s) + " "), t("Transition", [a === e.selected ? t("span", { staticClass: "c-tabs_tab_indicator absolute right-0 bottom-0 left-0" }) : e._e()])], 1);
  })], 2);
}, zn = [], Vn = /* @__PURE__ */ i(
  kn,
  Pn,
  zn,
  !1,
  null,
  "dbe87afa",
  null,
  null
);
const Mn = Vn.exports, jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mn
}, Symbol.toStringTag, { value: "Module" }));
var On = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z", fill: "currentColor" } })]);
};
const Fn = {
  render: On
};
const Rn = {
  name: "c-timeline",
  components: { PlusIcon: Fn }
};
var Bn = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "component", staticClass: "c-timeline" }, [e._t("default"), t("div", { staticClass: "c-timeline_action" }, [t("span", { staticClass: "c-timeline_action_add snz-txt-h4", on: { click: function(s) {
    return e.$emit("add");
  } } }, [t("plus-icon")], 1)])], 2);
}, An = [], In = /* @__PURE__ */ i(
  Rn,
  Bn,
  An,
  !1,
  null,
  "6eb4a02f",
  null,
  null
);
const Zn = In.exports, Ln = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zn
}, Symbol.toStringTag, { value: "Module" }));
var Nn = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M5 11h14v2H5z" } })]);
};
const Hn = {
  render: Nn
};
const qn = {
  name: "c-timeline-item",
  components: { MinusIcon: Hn }
};
var En = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "component", staticClass: "c-timeline-item" }, [t("div", { staticClass: "c-timeline-item_action" }, [t("span", { staticClass: "c-timeline-item_action_delete snz-txt-h4", on: { click: function(s) {
    return e.$emit("delete");
  } } }, [t("minus-icon")], 1)]), t("div", { staticClass: "c-timeline-item_content" }, [e._t("default")], 2)]);
}, Dn = [], Un = /* @__PURE__ */ i(
  qn,
  En,
  Dn,
  !1,
  null,
  "fb4ddd09",
  null,
  null
);
const Xn = Un.exports, Wn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xn
}, Symbol.toStringTag, { value: "Module" }));
var Gn = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { width: "24", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, n.$listeners), [t("path", { attrs: { d: "M12 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z", fill: "#000" } })]);
};
const Jn = {
  render: Gn
};
const Kn = {
  name: "c-dotmenu",
  components: { DotsIcon: Jn },
  props: {
    disabled: { type: Boolean, default: !1 }
  },
  setup() {
    const n = d(null), e = d(!1), t = d(!1), s = m({
      top: "0px",
      left: "0px"
    });
    return {
      component: n,
      openMenu: () => {
        const l = n.value.getBoundingClientRect();
        s.top = `${l.top}px`, s.left = `${l.right - 12}px`, e.value = !0;
      },
      showMenu: e,
      showButton: t,
      menuPosition: s
    };
  }
};
var Qn = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "component", staticClass: "c-dotmenu", on: { mouseover: function(s) {
    e.showButton = !0;
  }, mouseleave: function(s) {
    e.showButton = !1;
  } } }, [e.showMenu ? t("div", { staticClass: "c-dotmenu_overlay", on: { click: function(s) {
    s.stopPropagation(), e.showMenu = !1;
  } } }) : e._e(), e._t("default"), t("Transition", { attrs: { appear: "" } }, [!e.disabled && e.showButton ? t("div", { staticClass: "c-dotmenu_button", on: { click: e.openMenu } }, [t("dots-icon")], 1) : e._e()]), t("Transition", { attrs: { appear: "" } }, [!e.disabled && e.showMenu ? t("div", { staticClass: "c-dotmenu_menu", style: e.menuPosition }, [e._t("menu", null, { close: () => e.showMenu = !1 })], 2) : e._e()])], 2);
}, Yn = [], es = /* @__PURE__ */ i(
  Kn,
  Qn,
  Yn,
  !1,
  null,
  "9dc177ab",
  null,
  null
);
const ts = es.exports, ns = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ts
}, Symbol.toStringTag, { value: "Module" }));
export {
  K as avatar,
  te as bubble,
  Q as button,
  ve as card,
  ae as checkbox,
  as as default,
  pe as divider,
  be as dotmenu,
  ce as fileinput,
  _e as filter,
  se as image,
  le as input,
  fe as modal,
  re as radio,
  ue as select,
  de as selectMulti,
  Y as spinner,
  me as tabs,
  ee as tag,
  oe as textarea,
  ne as thumb,
  ge as timeline,
  he as timelineItem,
  ie as toggle
};
